import { LoginStateProps } from "./EnumsInterfaces";


const loginDefaultValues : LoginStateProps =  {
    loginCredential : {username: '', password: ''}, submitting: false, loading: false, success: true
}

export default loginDefaultValues;